/**
 * @generated SignedSource<<54d65b27b524dc6b2b96515a1e741cc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentsPanelReopenThreadMutation$variables = {
  id: string;
};
export type CommentsPanelReopenThreadMutation$data = {
  readonly Comment_ReopenThread: {
    readonly thread: {
      readonly id: string;
      readonly resolvedBy: {
        readonly id: string;
      } | null;
    };
  } | null;
};
export type CommentsPanelReopenThreadMutation = {
  response: CommentsPanelReopenThreadMutation$data;
  variables: CommentsPanelReopenThreadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "threadId",
        "variableName": "id"
      }
    ],
    "concreteType": "ReopenThread",
    "kind": "LinkedField",
    "name": "Comment_ReopenThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CommentThread",
        "kind": "LinkedField",
        "name": "thread",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "resolvedBy",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsPanelReopenThreadMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsPanelReopenThreadMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "61e2ad2bab4731d39bcd8aa7518b5136",
    "id": null,
    "metadata": {},
    "name": "CommentsPanelReopenThreadMutation",
    "operationKind": "mutation",
    "text": "mutation CommentsPanelReopenThreadMutation(\n  $id: ID!\n) {\n  Comment_ReopenThread(threadId: $id) {\n    thread {\n      id\n      resolvedBy {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2f0fdebef672784b6a72bc52fae3b83";

export default node;
